var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Select", {
    attrs: {
      label: _vm.label,
      value: _vm.value,
      disabled: _vm.disable,
      id: _vm.id,
      startVerific: _vm.startVerific,
      filterable: _vm.filterable,
      errmsg: _vm.errmsg,
      options: _vm.OPTIONS,
      placeholder: _vm.placeholder,
      isError: _vm.isError,
      isVerific: _vm.isVerific
    },
    on: { input: _vm.handleInput }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }